/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlertNotificationSetting } from '../../models/alert-notification-setting';

export interface FindByRoleName_1$Params {
  roleName: string;
}

export function findByRoleName_1(http: HttpClient, rootUrl: string, params: FindByRoleName_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AlertNotificationSetting>>> {
  const rb = new RequestBuilder(rootUrl, findByRoleName_1.PATH, 'get');
  if (params) {
    rb.path('roleName', params.roleName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AlertNotificationSetting>>;
    })
  );
}

findByRoleName_1.PATH = '/api/notification/alert/setting/roleName/{roleName}';
